import { neverHere } from "../tsHelpers";

export const asArray = (): LtoStatus[] => [
  "disabled",
  "hidden",
  "active",
];

export const toFriendlyName = (type: LtoStatus) => {
  switch (type) {
    case "disabled":
      return "Disabled";
    case "hidden":
      return "Hidden";
    case "active":
      return "Active";
    default:
      neverHere(type);
  }
};
